import { ref, type VNode } from 'vue'

export type NotificationType = 'success' | 'error' | 'warn'
export type ToasterMessage = {
  type?: NotificationType,
  title: string,
  description?: string | VNode,
  icon?: unknown,
  duration?: number
}
const messages = ref<ToasterMessage[]>([])

export const useToaster = () => {

  const notify = (options: ToasterMessage) => {
    if (messages.value.length === 3) messages.value.shift()
    messages.value.push({
      type: options.type,
      title: options.title,
      description: options.description,
      icon: options.icon,
      duration: options.duration,
    })
    setTimeout(() => {
      messages.value.shift()
    }, options.duration ?? 3000)
  }

  return {
    messages,
    notify,
  }
}

export const useToasterMessages = () => {
  return {
    messages,
  }
}
